import { MasterTranslation } from '@/constants';
import CarrierIcon from '@/public/images/icons/carrier.svg';
import OrderIcon from '@/public/images/icons/order.svg';
import MerchantIcon from '@/public/images/icons/store.svg';
import TrackingIcon from '@/public/images/icons/tracking.svg';

export const TRACKING_DETAILS_SECTIONS = {
  Tracking: {
    icon: TrackingIcon as React.ElementType,
    titleKey: MasterTranslation.Tracking,
  },
  Order: {
    icon: OrderIcon as React.ElementType,
    titleKey: MasterTranslation.Order,
  },
  Merchant: {
    icon: MerchantIcon as React.ElementType,
    titleKey: MasterTranslation.MerchantSectionHeader,
  },
  Carrier: {
    icon: CarrierIcon as React.ElementType,
    titleKey: MasterTranslation.HandledBy,
  },
};
